import { css } from "@emotion/css";
import { TextField } from "@octopusdeploy/design-system-components";
import { space, text } from "@octopusdeploy/design-system-tokens";
import { ExpandableFormSection, Summary } from "~/components/form";
type HelpSidebarSupportLinkProps = {
    link?: string;
    label?: string;
    linkError?: string;
    labelError?: string;
    onChangeLink: (link: string) => void;
    onChangeLinkLabel: (label: string) => void;
};
export function HelpSidebarSupportLink({ link, label, linkError, labelError, onChangeLink, onChangeLinkLabel }: HelpSidebarSupportLinkProps) {
    return (<ExpandableFormSection key="HelpSidebarSupportLink|HelpSidebarSupportLinkLabel" errorKey="HelpSidebarSupportLink|HelpSidebarSupportLinkLabel" title="Customize the Help Sidebar" summary={link ? Summary.summary(link) : Summary.default("Octopus support")} help="Customize the Help sidebar support link in the Octopus web portal UI.">
            <fieldset className={sidebarSupportLinkContainerStyles}>
                <p className={sidebarSupportLinkDescriptionStyles}>
                    The sidebar includes links to Octopus support and resources. This feature lets you add a custom link, so users can contact your internal support system. If you disable the sidebar feature, you can find the support link in the top
                    profile menu.
                </p>

                <TextField value={link || ""} onChange={onChangeLink} type="url" label="Support Link" description="Must include a valid URI scheme: http:, https:, mailto:, tel:" error={linkError} autoFocus={!!linkError}/>
                <TextField value={label || ""} onChange={onChangeLinkLabel} label="Support Link Label" description="Must be 2 to 38 characters. If left blank, this will default to 'Your organization's internal support'" error={labelError} autoFocus={!!labelError} type="text"/>
            </fieldset>
        </ExpandableFormSection>);
}
const sidebarSupportLinkContainerStyles = css({
    display: "grid",
    gap: space[24],
    border: 0,
    padding: 0,
    marginBottom: space[24],
});
const sidebarSupportLinkDescriptionStyles = css({
    font: text.body.regular.large,
    margin: 0,
});
